/**
 * Каталог событий воронки. Одно место, где решено, ЧТО именно считается, — по
 * тем же соображениям, что и `achp-catalog.ts` у моделлера: имя события,
 * набранное на экране руками, живёт до первой опечатки и потом навсегда
 * отсутствует в отчётах.
 *
 * ВОРОНКА ЭТОГО ПРИЛОЖЕНИЯ, а не воронка вообще. Лэндинг написан как воронка
 * (см. CODEBASE.md): бесплатное действие без аккаунта → регистрация → и дальше
 * две развилки, ради которых сайт существует, — собрать схему и дойти до
 * психолога. Считается ровно это.
 *
 * ЧЕГО В ПАРАМЕТРАХ НЕТ И НЕ БУДЕТ: адреса почты, имени, `username` психолога,
 * заголовка ситуации, текста сообщения, содержимого схемы. Только счётчики,
 * длительности и КОДЫ причин — короткие машинные строки из `reasonOf()`.
 * Правило не стилистическое: события уезжают третьей стороне, и то, что туда
 * попало, оттуда не удаляется.
 */
import { ApiError } from '@/shared/api/client'
import { track, type EventParams } from './gtag'

export const ACHP_EVENTS = {
  /** Форму регистрации отправили, сервер принял (202, письмо ушло). */
  signUp: 'sign_up',
  signUpFailed: 'sign_up_failed',
  /** Адрес подтверждён по ссылке из письма — вот здесь аккаунт становится живым. */
  signUpVerified: 'sign_up_verified',
  login: 'login',
  loginFailed: 'login_failed',

  /**
   * Главное бесплатное действие: схема сохранена. Первое, ради чего человека
   * зовут на сайт, и единственное, что он может довести до конца без аккаунта.
   */
  schemeSaved: 'scheme_saved',
  /** Схему опубликовали ссылкой — она ушла за пределы сайта и приведёт людей. */
  schemeShared: 'scheme_shared',

  /** Главное платное действие: написал психологу и попросился на сессию. */
  psychologistContacted: 'psychologist_contacted',
  psychologistContactFailed: 'psychologist_contact_failed',
  appointmentRequested: 'appointment_requested',
  appointmentRequestFailed: 'appointment_request_failed',

  /** Заявка в бету приложения — единственная форма для тех, у кого нет аккаунта. */
  betaSignup: 'beta_signup',
  betaSignupFailed: 'beta_signup_failed',

  /** Ответ на плашку согласия. Машинный код выбора, больше ничего. */
  consentChoice: 'consent_choice',
} as const

/**
 * Причина отказа одной короткой машинной строкой.
 *
 * Из ошибки берутся ТОЛЬКО код сервера и статус — никогда `message`: текст
 * отказа переведён, иногда содержит адрес почты («на hello@… уже есть
 * аккаунт») и в аналитике превратился бы в утечку с человеческим лицом.
 * Отсутствие ответа отделено от отказа сервера: «сеть не дошла» и «сервер
 * сказал нет» — разные проблемы с разной ценой.
 */
export function reasonOf(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.code) return error.code.toLowerCase().slice(0, 40)
    return `http_${error.status}`
  }
  if (error instanceof TypeError) return 'network'
  return 'unknown'
}

/** Событие отказа: причина плюс, если есть, что-то ещё машинное. */
export function trackFailure(name: string, error: unknown, params: EventParams = {}): void {
  track(name, { reason: reasonOf(error), ...params })
}
